import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateTermsAndConditionSchema } from "@/v2/schema/terms-and-conditions";
import { TermsAndCondition } from "@/v2/types";

export default async function UpdateTermsAndCondition({
    id,
    data,
}: {
    id: string;
    data: CreateTermsAndConditionSchema;
}): Promise<TermsAndCondition> {
    const res = await apiClientWithRefreshToken({
        url: `/terms-and-conditions-templates/${id}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
